import { render, staticRenderFns } from "./ModalReportGlobal.vue?vue&type=template&id=9834e1ea"
import script from "./ModalReportGlobal.vue?vue&type=script&lang=js"
export * from "./ModalReportGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports